import { c as _c } from "react/compiler-runtime";
import { useGlobalCmsContentContext } from '../../../components/providers/global-cms-context';
import { getYesNoLabel } from './getYesNoLabel';
export const useGetYesNoLabel = () => {
  const $ = _c(3);
  const {
    cmsContent
  } = useGlobalCmsContentContext();
  let t0;
  if ($[0] !== cmsContent.noLabel || $[1] !== cmsContent.yesLabel) {
    t0 = value => getYesNoLabel(value, {
      noLabel: cmsContent.noLabel,
      yesLabel: cmsContent.yesLabel
    });
    $[0] = cmsContent.noLabel;
    $[1] = cmsContent.yesLabel;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};